// extracted by mini-css-extract-plugin
module.exports = {"triforceImage":"Triforce_triforceImage__0iSFp"};